var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurolatorStoreLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(21.3333)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8408 0.90625C23.8408 0.492036 23.505 0.15625 23.0908 0.15625H0.90625C0.492036 0.15625 0.15625 0.492036 0.15625 0.90625V23.0908C0.15625 23.505 0.492036 23.8408 0.90625 23.8408H8.19639C8.20662 23.8412 8.21691 23.8414 8.22724 23.8414H16.8552C16.8654 23.8414 16.8755 23.8412 16.8856 23.8408H23.0908C23.505 23.8408 23.8408 23.505 23.8408 23.0908V0.90625ZM8.97724 22.3408H16.1052V13.9811H8.97724V22.3408ZM17.6052 13.2311V22.3408H22.3408V1.65625H1.65625V22.3408H7.47724V13.2311C7.47724 12.8169 7.81303 12.4811 8.22724 12.4811H16.8552C17.2692 12.4813 17.6052 12.817 17.6052 13.2311ZM20.6263 3.37135H3.37135V9.53384H20.6263V3.37135ZM10.4581 16.9287C9.94763 16.9287 9.53377 17.3426 9.53377 17.8531V19.0856C9.53377 19.5961 9.94763 20.01 10.4581 20.01C10.9687 20.01 11.3825 19.5961 11.3825 19.0856V17.8531C11.3825 17.3426 10.9687 16.9287 10.4581 16.9287Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurolatorStoreLg);
export default __webpack_public_path__ + "static/media/Purolator-store-lg.5ab037e070befcd3ceefb8bd8648ef14.svg";
export { ForwardRef as ReactComponent };